module.exports = __webpack_public_path__ + "static/media/iconCanvas13.e7a6e974.svg";